import dayjs from "dayjs";
import numberCalculate from "./numberCalculate";

export default class CouponParser {
  constructor(coupon) {
    this.meta = coupon;
    Object.keys(coupon).forEach(key => {
      Object.defineProperty(this, key, {
        get() {
          return coupon[key];
        },
        set() {
          console.log("");
        }
      });
    });
  }

  get type() {
    return ["", "普通", "代金券", "折扣券"][this.meta.coupon_type];
  }

  get title() {
    return this.meta.title;
  }

  get guid() {
    return this.meta.guid;
  }

  get value() {
    switch (this.meta.coupon_type) {
      case 0:
        return "未知";
      case 1:
        return "普通券";
      case 2:
        return this.meta.coupon_value + "元";
      case 3:
        return numberCalculate.multiply(this.meta.coupon_value, 10) + "折";
    }
    return "";
  }

  get duration() {
    const time = this.meta.duration_time;
    if (typeof time === "string") return time;
    const day = dayjs(time);
    return day.isValid() ? day.format("YYYY-MM-DD") + "有效" : time;
  }

  get limit() {
    if (!this.meta.min_consume_value) return "无使用门槛";
    return `满${this.meta.min_consume_value}元可用`;
  }
}
